import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EvidenceCollection = ({ selectedCase }) => {
  const [evidenceItems, setEvidenceItems] = useState([
    {
      id: 1,
      type: 'screenshot',
      name: 'Login attempt screenshot',
      timestamp: new Date()?.toISOString(),
      status: 'verified',
      hash: 'a3f5c8d9e2b1f4a7'
    },
    {
      id: 2,
      type: 'log',
      name: 'System access logs',
      timestamp: new Date()?.toISOString(),
      status: 'pending',
      hash: 'b7e4d2c1a9f8e3b6'
    }
  ]);

  const getTypeIcon = (type) => {
    const icons = {
      screenshot: 'Image',
      log: 'FileText',
      document: 'File',
      video: 'Video',
      audio: 'Mic'
    };
    return icons?.[type] || 'File';
  };

  const getStatusColor = (status) => {
    const colors = {
      verified: 'var(--color-success)',
      pending: 'var(--color-warning)',
      rejected: 'var(--color-error)'
    };
    return colors?.[status] || 'var(--color-muted)';
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
      {/* Evidence List */}
      <div className="lg:col-span-2 card">
        <div className="flex items-center justify-between mb-6">
          <h3 className="text-xl font-heading font-semibold text-foreground">
            Evidence Collection
          </h3>
          <Button variant="default" size="sm">
            <Icon name="Plus" size={16} className="mr-2" />
            Add Evidence
          </Button>
        </div>

        <div className="space-y-3">
          {evidenceItems?.map((item) => (
            <div key={item?.id} className="p-4 border border-border rounded-lg hover:border-primary/50 transition-all duration-250">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Icon name={getTypeIcon(item?.type)} size={20} className="text-primary" />
                </div>
                <div className="flex-1">
                  <div className="flex items-center justify-between mb-2">
                    <h4 className="text-sm font-medium text-foreground">{item?.name}</h4>
                    <span
                      className="px-2 py-0.5 rounded text-xs font-medium"
                      style={{
                        backgroundColor: `${getStatusColor(item?.status)}15`,
                        color: getStatusColor(item?.status)
                      }}
                    >
                      {item?.status}
                    </span>
                  </div>
                  <div className="flex items-center gap-4 text-xs text-muted-foreground">
                    <span className="flex items-center gap-1">
                      <Icon name="Clock" size={12} />
                      {new Date(item?.timestamp)?.toLocaleString()}
                    </span>
                    <span className="flex items-center gap-1">
                      <Icon name="Hash" size={12} />
                      {item?.hash}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Chain of Custody */}
      <div className="card">
        <h3 className="text-lg font-heading font-semibold text-foreground mb-4">
          Chain of Custody
        </h3>

        <div className="space-y-4">
          <div className="p-3 bg-muted/50 rounded-lg">
            <div className="flex items-center gap-2 mb-2">
              <Icon name="Shield" size={16} className="text-success" />
              <span className="text-sm font-medium text-foreground">Evidence Integrity</span>
            </div>
            <p className="text-xs text-muted-foreground">All evidence items are cryptographically verified</p>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground mb-3">Custody Log</h4>
            <div className="space-y-2">
              <div className="flex items-start gap-2 text-xs">
                <div className="w-2 h-2 rounded-full bg-primary mt-1.5" />
                <div>
                  <p className="text-foreground font-medium">Evidence collected</p>
                  <p className="text-muted-foreground">By: System Admin • {new Date()?.toLocaleString()}</p>
                </div>
              </div>
              <div className="flex items-start gap-2 text-xs">
                <div className="w-2 h-2 rounded-full bg-muted mt-1.5" />
                <div>
                  <p className="text-foreground font-medium">Verification pending</p>
                  <p className="text-muted-foreground">Awaiting forensic analysis</p>
                </div>
              </div>
            </div>
          </div>

          <div className="pt-4 border-t border-border">
            <Button variant="outline" size="sm" className="w-full">
              <Icon name="Download" size={16} className="mr-2" />
              Export Evidence Package
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EvidenceCollection;